import toDate from '../to-date';

export const getDay = (date: Date | number): number => {
  return toDate(date).getDay();
};

export default getDay;
